import React from 'react';
import localization from '../helpers/localization'

const PlanChangeTable = ({ rows }) => (<div>
    {rows ? buildTable(rows) : <h2>Ei muutoksia</h2>}
</div>
);
export default PlanChangeTable;

const buildTable = (rows) => {
    return rows.length > 0 ? (<table className="productTable">
        <thead><tr><th>Muutos</th><th>Hinta</th></tr></thead>
        <tbody>
            {rows.map(row => <tr key={row.description}><td>{row.description}</td><td>{row.cost.toFixed(2) + " €"}</td></tr>)}
        </tbody>
        <tfoot><tr><td>{localization.total}</td><td>{rowTotal(rows).toFixed(2) + " €"}</td></tr></tfoot>
    </table>) : "";

}

let rowTotal = (rows) => {
    let total = 0;
    for (let i = 0; i < rows.length; i++) {
        total += rows[i].cost;
    }
    return total;
}